// extracted by mini-css-extract-plugin
export var cRow = "styles-module--c-row--78971";